import photo from "../../assets/jpg/no_image.jpg";
import { ResendInvitation } from "../../assets/svg";
import { useTranslate } from "../../hooks/useTranslate";
import { ICollaborator } from "../../modules/collaborator/interfaces";
import {
  Container,
  Photo,
  AboutCollaborator,
  DescriptionCollaborator,
  StatusInvite,
  EditAccess,
} from "./styles";

type Props = {
  cb?: () => void;
} & Pick<
  ICollaborator,
  "status" | "created_at" | "name" | "office" | "isOwner"
>;

const Collaborator = ({
  status = false,
  created_at,
  name,
  office,
  isOwner = false,
  cb,
}: Props) => {
  const { translate } = useTranslate();

  return (
    <Container>
      <Photo src={photo} alt="Collaborator" />
      <AboutCollaborator>
        <DescriptionCollaborator>
          <p>{name}</p>
          <span>{office}</span>
          {!isOwner && created_at && (
            <span>
              {translate("collaborator.invivation_sent")} {created_at}
            </span>
          )}
        </DescriptionCollaborator>
        {!isOwner && cb != null && (
          <>
            {status ? (
              <EditAccess onClick={cb}>
                {translate("collaborator.edit_access")}
              </EditAccess>
            ) : (
              <StatusInvite onClick={cb}>
                <span>{translate("collaborator.invivation_pending")}</span>
                <ResendInvitation />
              </StatusInvite>
            )}
          </>
        )}
      </AboutCollaborator>
    </Container>
  );
};

export { Collaborator };
